export default __webpack_public_path__ + "static/logo-nvidia-be1d27d5eff881c3dc03db60c93f7e57.png";